import { Skeleton } from '@/components/ui/skeleton';

export const OrganizationFormSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Service User and Type row */}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" /> {/* Label */}
          <Skeleton className="h-10 w-full" /> {/* Input */}
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-16" /> {/* Label */}
          <Skeleton className="h-10 w-full" /> {/* Select */}
        </div>
      </div>

      {/* Abbreviation and Country row */}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-28" /> {/* Label */}
          <Skeleton className="h-10 w-full" /> {/* Input */}
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" /> {/* Label */}
          <Skeleton className="h-10 w-full" /> {/* Select */}
        </div>
      </div>

      {/* Website field */}
      <div className="grid grid-cols-1 gap-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" /> {/* Label */}
          <Skeleton className="h-10 w-full" /> {/* Input */}
        </div>
      </div>

      {/* Wings Id field */}
      <div className="grid grid-cols-1 gap-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" /> {/* Label */}
          <Skeleton className="h-10 w-full" /> {/* Input */}
        </div>
      </div>

      {/* Checkboxes row */}
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center space-x-2">
          <Skeleton className="h-4 w-4" /> {/* Checkbox */}
          <Skeleton className="h-4 w-20" /> {/* Label */}
        </div>
        <div className="flex items-center space-x-2">
          <Skeleton className="h-4 w-4" /> {/* Checkbox */}
          <Skeleton className="h-4 w-32" /> {/* Label */}
        </div>
      </div>
    </div>
  );
};
